import { axios } from '@/utils/request'

const api = {
    sihaoList: '/adminapi/csihao/sihaoList',
    sihaoDetail: '/adminapi/csihao/sihaoDetail',
    editSihao: '/adminapi/csihao/editSihao',
  deleteSihao: '/adminapi/csihao/sihaoDelete',
  memberList: '/adminapi/csihao/memberList',
  memberDetail: '/adminapi/csihao/memberDetail',
  memberEdit: '/adminapi/csihao/memberEdit',
  memberDelete: '/adminapi/csihao/memberDelete',
  sihaoDeleteAll: '/adminapi/csihao/sihaoDeleteAll',
  sihaoStatusAll: '/adminapi/csihao/sihaoStatusAll',
  sihaoDownloadUrl: '/adminapi/csihao/sihaoDownloadUrl',
  sihaoImport: '/adminapi/csihao/sihaoImport',
  setBaijiaAll: '/adminapi/csihao/setBaijiaAll',
}

export default api

export function getSihaoList(parameter) {
  return axios({
    url: api.sihaoList,
    method: 'get',
    params: parameter
  })
}

export function getSihaoDetail(parameter) {
  return axios({
    url: api.sihaoDetail,
    method: 'get',
    params: parameter
  })
}
export function editSihao(parameter) {
  return axios({
    url: api.editSihao,
    method: 'post',
    data: parameter
  })
}

export function deleteSihao(parameter) {
  return axios({
    url: api.deleteSihao,
    method: 'post',
    data: parameter
  })
}

export function sihaoDeleteAll(parameter) {
  return axios({
    url: api.sihaoDeleteAll,
    method: 'post',
    data: parameter
  })
}

export function sihaoStatusAll(parameter) {
  return axios({
    url: api.sihaoStatusAll,
    method: 'post',
    data: parameter
  })
}

export function getSihaoDownloadUrl(parameter) {
  return axios({
    url: api.sihaoDownloadUrl,
    method: 'get',
    params: parameter
  })
}

export function getApplyMemberList(parameter) {
  return axios({
    url: api.memberList,
    method: 'post',
    data: parameter
  })
}
export function memberEdit(parameter) {
  return axios({
    url: api.memberEdit,
    method: 'post',
    data: parameter
  })
}
export function sihaoImport(parameter) {
  return axios({
    url: api.sihaoImport,
    method: 'post',
    data: parameter
  })
}
export function setBaijiaAll(parameter) {
  return axios({
    url: api.setBaijiaAll,
    method: 'post',
    data: parameter
  })
}

export function memberDetail(parameter) {
  return axios({
    url: api.memberDetail,
    method: 'get',
    params: parameter
  })
}
export function memberDelete(parameter) {
  return axios({
    url: api.memberDelete,
    method: 'get',
    params: parameter
  })
}
